import React, {Component, Fragment} from 'react';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import DEFINE, { CONFIG_PHS_ENUM } from "../../../../constants/Define";
import ConfigPHSInfo from './ConfigPHS';
import ConfigPHS from '../../../../models/ConfigPHS';
import { Tabs } from 'antd';
import { isEqual, cloneDeep } from 'lodash';

let permisionActions = [];

const { TabPane } = Tabs;
const defaultState = {
    activeTab: 'Hotel'
};

export default class PHSMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            configPhs: new ConfigPHS(),
            configPHSs: []
        };
    }
    
    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.FARE_RULES);
        this.props.getConfigPHS();
    }

    componentWillUnmount() {
        this.props.setConfigPHS([])
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.configPHSState.configPHS && !isEqual(this.props.configPHSState.configPHS, nextProps.configPHSState.configPHS)) {
            const temp = nextProps.configPHSState.configPHS.find(item => item.type === this.state.activeTab)
            this.setState({ configPHSs: cloneDeep(nextProps.configPHSState.configPHS), configPhs: temp });
        }
    }

    render(){
        const { t } = this.props;
        const { activeTab, configPhs } = this.state;
        return(
            <Fragment>
                <HMS.PageListComponent>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'configPHS'}
                    />
                        <Tabs defaultActiveKey={ activeTab } onChange={ this.onChangeTab } activeKey={ activeTab } animated={ false }>
                            <TabPane tab={ t('item.configPHS.hotel') } key="Hotel">
                                <ConfigPHSInfo 
                                    {...this.props}
                                    configPhs={configPhs}
                                    onChange={this.onChange}
                                    onCancelEdit={this.onCancelEdit}
                                    type='Hotel'
                                />
                            </TabPane>
                            <TabPane tab={ t('item.configPHS.bundle') } key="Bundle">
                                <ConfigPHSInfo 
                                    {...this.props}
                                    configPhs={configPhs}
                                    onChange={this.onChange}
                                    onCancelEdit={this.onCancelEdit}
                                    type='Bundle'
                                />
                            </TabPane>
                        </Tabs>
                    </HMS.PageListComponent>
            </Fragment>
        )
    }

    onChangeTab = (keyActive) => {
        const { configPHSs } = this.state;
        const temp = configPHSs.find(item => item.type === keyActive)
        this.setState({ activeTab: keyActive, configPhs: temp });
    }

    onChange = (fieldName, value)=>{
        const { configPhs } = this.state;
        configPhs[fieldName] = value;
        this.setState({ configPhs })
    }

    onCancelEdit = ()=>{
       this.onChangeTab(this.state.activeTab);
    }

}